// 仅将密文叶子发往查看接口；全部返回合法后，才生成供页面回填的新对象。
const MAX_FIELDS = 100;
const MAX_CIPHERTEXT_LENGTH = 16384;
export const isSensitiveCiphertext = value => typeof value === 'string' && /^\{\$[A-Za-z0-9+/=]+\$\}$/.test(value.trim());

function invalid(key) {
  const error = new Error(key);
  error.sensitiveMessageKey = `sensitiveView.${key}`;
  throw error;
}

export async function decryptSensitiveData(data, send) {
  const fields = {};
  const locations = new Map();
  const visited = new WeakSet();
  let count = 0;
  function collect(value) {
    if (typeof value === 'string' && value.trim().startsWith('{$')) {
      if (!isSensitiveCiphertext(value)) invalid('invalid');
      if (value.length > MAX_CIPHERTEXT_LENGTH) invalid('limit');
      if (!locations.has(value)) {
        if (count >= MAX_FIELDS) invalid('limit');
        const key = `field${count++}`;
        locations.set(value, key);
        fields[key] = value;
      }
    } else if (value && typeof value === 'object') {
      if (visited.has(value)) invalid('invalid');
      visited.add(value);
      Object.keys(value).forEach(key => collect(value[key]));
      visited.delete(value);
    }
  }
  collect(data);
  function restore(value, resolved) {
    if (resolved && locations.has(value)) return resolved[locations.get(value)];
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map(item => restore(item, resolved));
    return Object.fromEntries(Object.keys(value).map(key => [key, restore(value[key], resolved)]));
  }
  const snapshot = restore(data, null);
  const response = count ? await send({ data: fields }) : { code: 200, data: {}};
  if (!response || response.code !== 200 || !response.data) invalid('failed');
  Object.keys(fields).forEach(key => {
    if (!Object.prototype.hasOwnProperty.call(response.data, key) || typeof response.data[key] !== 'string' || isSensitiveCiphertext(response.data[key])) invalid('failed');
  });
  return { ...response, data: restore(snapshot, response.data) };
}

// 已脱敏的展示值不能作为编辑结果写回。
export function containsSensitivePlaceholder(value) {
  if (typeof value === 'string') return value.trim().startsWith('{$') || /^\*{4,}$/.test(value.trim());
  return !!value && typeof value === 'object' && Object.values(value).some(containsSensitivePlaceholder);
}
